import _ from 'lodash';
import browserPlatform from '../platform/browser';
import { downloadTypes, reports } from './constant';
import * as handlers from './handlers';

export const getFileNameFromUrl = (url = '') => {
  const name = decodeURI(
    _.replace(url, /%2F/g, '/')
      .split('/')
      .pop()
      .substring(_.replace(url, /%2F/g, '/').split('/').pop().indexOf('-') + 1),
  );
  if (name.lastIndexOf('?') > -1) {
    return name.substring(0, name.lastIndexOf('?'));
  }
  return name;
};
export const fileTypeExport = (exportType) => {
  switch (exportType) {
    case 'ZIP':
      return 'application/zip';
    case downloadTypes.PDF:
      return 'application/pdf';
    case downloadTypes.CSV:
      return 'text/csv';
    case downloadTypes.EXCEL:
      return 'application/vnd.sealed.xls';
    default:
  }
};
export const makeDownloadReady = (response, extenstionType, reportType) => {
  let exportType = extenstionType;
  if (reports.BULK === reportType) {
    exportType = 'ZIP';
  }
  try {
    const blob = new Blob([response], {
      type: fileTypeExport(exportType),
    });
    const extension = fileTypeExport(exportType).slice(-3);
    let fileName = `${reportType}.${extension}`;

    if (reports.BULK === reportType) {
      fileName = `Bulk Statement Report.${extension}`;
    }

    browserPlatform.downloadBlob(blob, fileName);
    handlers.successHandler({
      message: {
        message: 'File Downloaded successfully',
        title: 'Success',
      },
    });
  } catch (err) {
    handlers.apiErrorHandler(err);
  }
};

export const asyncDebounce = (func, wait) => {
  const debounced = _.debounce((resolve, reject, args) => {
    func(...args)
      .then(resolve)
      .catch(reject);
  }, wait);
  return (...args) =>
    new Promise((resolve, reject) => {
      debounced(resolve, reject, args);
    });
};
export const getModifiedIndividualData = (result) => {
  const individualData = result;
  if (individualData && individualData.length > 0) {
    for (let index = 0; index < individualData.length; index += 1) {
      if (index === 0) {
        individualData[index].balanceDue = individualData[index].totalAmount;
      } else if (
        individualData[index].name.includes('Payment') ||
        individualData[index].name.includes('Discount') ||
        individualData[index].name === 'Paid'
      ) {
        individualData[index].balanceDue =
          +individualData[index - 1]?.balanceDue.toFixed(2) -
          +individualData[index]?.totalAmount.toFixed(2);
      } else {
        individualData[index].balanceDue =
          +individualData[index - 1]?.balanceDue.toFixed(2) +
          +individualData[index]?.totalAmount.toFixed(2);
      }
    }
  }
  return individualData;
};
